import React from "react";
import { Grid } from "@material-ui/core";
import { InputTextMaster } from "App/Component/ui";
import { messageError } from "utils/all";
import MasterButton from "App/Component/ui/button/MasterButton";
import { convertDateToValidInput, getAge } from "App/utils/helpers";
import Refresh from "App/Assets/icons/Refresh";
import { dateFormat } from "utils/dates";

export default function FormDataPasien({
  formData,
  setFormData,
  handleChange,
  registrationId,
}) {
  return (
    <>
      <p className="fw-600 fs-12">DATA PASIEN</p>
      <div className="mt-1">
        <Grid container spacing={1}>
          <Grid item sm={2}>
            <InputTextMaster
              name="patients_id"
              label="ID RM"
              id="patients_id"
              type="number"
              disabled={true}
              placeholder="ID RM"
              value={formData.patients_id}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="nama_rm"
              label="NAMA RM"
              id="nama_rm"
              disabled={true}
              placeholder="Nama RM"
              value={formData.nama_rm}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="gender"
              label="JENIS KELAMIN"
              id="gender"
              disabled={true}
              placeholder="Jenis Kelamin"
              value={formData.gender}
            />
          </Grid>
          <Grid item sm={4}>
            <div
              style={{
                display: "flex",
                gap: "5px",
              }}
            >
              <InputTextMaster
                name="umur"
                label="UMUR"
                id="umur"
                placeholder="Umur"
                value={formData.umur}
                onChange={handleChange("umur")}
              />
              <MasterButton
                type={"button"}
                color="warning"
                name=""
                size="sm"
                withIcon={true}
                onClick={() => {
                  // setFormData({
                  //   ...formData,
                  //   umur: getAge(dateFormat({ date: formData.date_ob, formatDate: 'YYYY-MM-DD' })),
                  // });
                  const dateOb = formData.date_ob;
                  if (!dateOb) return;

                  const datePart = typeof dateOb === 'string' ? dateOb.split('T')[0] : dateOb;
                  
                  setFormData({
                    ...formData,
                    umur: getAge(datePart),
                  });
                }}
                style={{
                  marginTop: "1.6rem",
                  width: "32px",
                  height: "32px",
                }}
                icon={
                  <Refresh
                    width="16px"
                    height="16px"
                    style={{
                      marginLeft: "-0.56rem",
                      marginBottom: "0.2rem",
                    }}
                  />
                }
              />
            </div>
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name="nohp"
              label="NO HP"
              id="nohp"
              placeholder="No HP"
              value={formData.nohp}
              onChange={handleChange("nohp")}
              error={true}
              message={messageError.required}
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name="phone_number"
              label="TELEPON"
              id="phone_number"
              disabled={true}
              placeholder="Telepon"
              value={formData.phone_number}
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name="address_now"
              label="ALAMAT SEKARANG"
              id="address_now"
              disabled={true}
              placeholder="Alamat"
              value={formData.address_now}
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name="pekerjaan"
              label="PEKERJAAN"
              id="pekerjaan"
              disabled={true}
              placeholder="Pekerjaan"
              value={formData.pekerjaan}
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name="penanggung"
              label="PENANGGUNG"
              id="penanggung"
              disabled={true}
              placeholder="Penanggung"
              value={formData.penanggung}
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name="nik"
              label="NIK"
              id="nik"
              disabled={true}
              placeholder="NIK"
              value={formData.nik}
              error={true}
              message={"Jika kosong, silahkan cek profile rekam medis"}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
}
